import { colors } from '@/constants';
import styled from 'styled-components';
import { RiCheckboxCircleFill } from 'react-icons/ri';

export const BoxQtdEmbalagem = styled.div`
  background-color: transparent;
`;

export const QtdEmbalagem = styled.div`
  white-space: nowrap;
  font-weight: 400;
  font-size: 10px;
  text-align: left;
  line-height: 100%;
  margin-bottom: 0px;
  color: ${colors.brand.grafite};
`;

export const Row = styled.div`
  gap: 5px;
  margin-top: 5px;
  flex-direction: row;
  display: flex;
  width: 100%;
`;

export const CheckFill = styled(RiCheckboxCircleFill)`
  top: -10px;
  right: -10px;
  position: absolute;
  border-radius: 50%;
  background-color: ${colors.brand.white};
`;

export const PackImage = styled.img``;

export const BoxEmbalagem = styled.div<{ $isactive: boolean; size?: number; $unityPack: boolean; $fullBorder?: boolean }>`
  gap: 5px;
  max-width: ${(i) => (i.$unityPack ? '50%' : '100%')};
  height: ${(i) => i.size || 50}px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  cursor: pointer;
  padding: 8px 0px 4px 0px;
  padding: ${(i) => (i.$fullBorder ? '8px 0px' : '8px 0px 4px 0px')};
  position: relative;
  align-items: center;
  justify-content: center;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  transition: all 0.35s;

  border-radius: ${(i) => (i.$fullBorder ? '6px' : '6px 6px 0px 0px')};
  background-color: ${(i) => (i.$isactive ? colors.brand.white : colors.transparent)};

  border: 2px solid ${(i) => (i.$isactive ? colors.brand.grafite : colors.transparent)};
  border-bottom: ${(i) => {
    if (i.$isactive && !i.$fullBorder) return 'none';
    return (i.$fullBorder && i.$isactive ? colors.brand.grafite : colors.transparent) + ' 2px solid';
  }};
  @media screen and (max-width: 405px) {
    width: auto !important;
    padding: 0 6px !important;
  }
`;

export const BoxLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.brand.grafite};
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
  line-height: normal;
`;
